import { toBN } from '@utils/formaters.utils';

export enum SlippageError {
  InvalidInput = 'InvalidInput',
  RiskyLow = 'RiskyLow',
  RiskyHigh = 'RiskyHigh',
}

export const SLIPPAGE_MESSAGE_ERROR = {
  [SlippageError.InvalidInput]: 'Enter a valid badge percentage',
  [SlippageError.RiskyHigh]: 'Your transaction may fail',
  [SlippageError.RiskyLow]: 'Your transaction may be frontrun',
};

export const SLIPPAGE_TOLERANCE_OPTIONS = [
  {
    value: '0.1',
  },
  {
    value: '0.5',
  },
  {
    value: '1.0',
  },
];

export const MIN_VALID_VALUE = 0;

export const MAX_VALID_VALUE = 49.99;

export const MIN_SUCCESS_VALID_VALUE = 0.5;

export const MAX_DECIMALS_REGEX = /^\d*\.?\d{0,2}$/;

export const INPUT_REGEX = RegExp('^\\d*(?:\\\\[.])?\\d*$');

export const DEFAULT_SLIPPAGE_PARAM = toBN(0.995);
